/**
 * @typedef AT_UPDATE_STEP
 * @property {string} symbol 코인 명
 * @property {AT_UPDATE_STEP_ITEM[]} list 저장/수정/삭제 할 데이터 리스트
 *
 */

/**
 * @typedef AT_UPDATE_STEP_ITEM 저장/수정/삭제할 데이터 아이템
 * @property {number|null} id 단계별 pk
 * @property {double} price 매도 금액
 * @property {double} percent 퍼센트
 */

const sellStepStore = {
  namespaced: true,
  state: {
    init: true,
    BTCUSDT: [{ step: 1, id: 1, price: 0, percent: 0, isTraded: false }],
    ETHUSDT: [{ step: 1, id: 2, price: 0, percent: 0, isTraded: false }],
    XRPUSDT: [{ step: 1, id: 3, price: 0, percent: 0, isTraded: false }],
    SOLUSDT: [{ step: 1, id: 4, price: 0, percent: 0, isTraded: false }],
    ADAUSDT: [{ step: 1, id: 5, price: 0, percent: 0, isTraded: false }],
    DOGEUSDT: [{ step: 1, id: 6, price: 0, percent: 0, isTraded: false }],
    BNBUSDT: [{ step: 1, id: 7, price: 0, percent: 0, isTraded: false }],
  },
  getters: {
    IS_INIT: (state) => state.init,
    CURRENT_STEP: (state) => (symbol) => {
      return (
        state[symbol].filter((f) => f.isTraded) &&
        state[symbol].filter((f) => !f.isTraded)[0]
      );
    },
    ALL_STEP: (state) => (symbol) => {
      return state[symbol];
    },
  },
  mutations: {
    MU_SELL_SAVE_STEPS: (state, payload) => {
      const tempData = payload.list.map((data, index) => {
        return {
          id: data.id,
          price: data.price,
          percent: data.percent,
          isTraded: false,
          step: index + 1,
        };
      });

      state[payload.symbol] = tempData;
    },
  },

  actions: {
    /**
     * 매수 설정 데이터 업데이트
     * @param {Object} param0
     * @param {AT_UPDATE_STEP} payload
     */
    AT_SELL_UPDATE_STEP: async ({ commit }, payload) => {
      // api 로직 작성 예정

      commit("MU_SELL_SAVE_STEPS", payload);
    },

    // /**
    //  * 초기 데이터 로드 로직
    //  * @param {*} param0
    //  */
    // AT_LOAD_STEP: async ({ commit }) => {
    //   // api 로직 작성 예정
    // },
  },
};

export default sellStepStore;
